import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";

const useCommonParams = (moduleName, props, fetchData, updateData) => {
  const dispatch = useDispatch();
  const initialRequestHasSent = useSelector((state) => state[moduleName].initRequest);
  const prevDate = useSelector((state) => state[moduleName].prevPageFilters.prevDate);

  const date = useSelector((state) => state.dashboardFilters.date);

  return {
    initialRequestHasSent,
    date,
    hasChangedDate: prevDate !== date,
    onFetch: (params) => dispatch(fetchData({ user: props, date, ...params })),
    onUpdate: (params = {}) => dispatch(updateData({ date, ...params }))
  };
};

export const useFetchDataWithRevenueType = ({ props, moduleName, fetchData, updateData }) => {
  const revenue_type = useSelector((state) => state.dashboardFilters.revenue_type.id);
  const prevRevenueType = useSelector((state) => state[moduleName].prevPageFilters.prevRevenueType);

  const { initialRequestHasSent, date, hasChangedDate, onFetch, onUpdate } = useCommonParams(
    moduleName,
    props,
    fetchData,
    updateData
  );

  const hasChangedFilters = prevRevenueType !== revenue_type || hasChangedDate;

  useEffect(() => {
    if (date && revenue_type && hasChangedFilters) {
      initialRequestHasSent ? onUpdate({ revenue_type }) : onFetch({ revenue_type });
    }
  }, [date, revenue_type]);
};

export const useFetchData = ({ moduleName, props, fetchData, updateData }) => {
  const { initialRequestHasSent, date, hasChangedDate, onFetch, onUpdate } = useCommonParams(
    moduleName,
    props,
    fetchData,
    updateData
  );

  useEffect(() => {
    if (date && hasChangedDate) {
      initialRequestHasSent ? onUpdate() : onFetch();
    }
  }, [date]);
};
